import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export function logErrorHandler(error, info){
  console.log('error', error);
  console.log('info', info);
}
export default function ErrorBoundaryFallBack({ error, resetErrorBoundary }) {
  useEffect(() => {      
    // Sentry.setContext("character", {
    //   name: "Mighty Fighter",
    //   age: 19,
    //   attack_type: "melee",
    // });
    // // const scope = new Sentry.Scope();    
    // Sentry.setTag("section", "middleware");
    // Sentry.captureException(new Error("something went wrong"), { tags: tags });
    console.log('check instance', error instanceof Error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>      
    </div>
  );
}
